import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    // QrStatus_OK (1) specifies that the QR Code was generated successfully.
    { value: 1, label: 'Ok' },
    // QrStatus_ERROR (2) specifies an unknown server error has occurred while
    // attempting to generate the QR code.
    { value: 2, label: 'Error' },
    // QrStatus_USER_NOT_FOUND (3) specifies that the user record was unable to
    // be found for the given person that the QR Code was being generated for.
    { value: 3, label: 'User Not Found' },
    // QrStatus_USER_ACCOUNT_DISABLED (4) specifies that the user account has
    // been locked, stopping the user from being able to sign in and as such,
    // generate a new sign in token.
    { value: 4, label: 'User Account Disabled' },
  ],
});
